import React, { Component } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import './custom.css'
import 'moment/locale/fr';
import moment from  'moment-timezone';
import Moment from 'react-moment';
import { RegistrationPage } from './components/Registration/RegistrationPage';

Moment.globalMoment = moment;
Moment.globalTimezone ="Europe/Paris";
Moment.globalLocale = 'fr';
Moment.globalLocal = true;
Moment.globalElement = 'span';
Moment.globalFormat = 'dddd D MMMM YYYY, HH:mm';

export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
      <Routes>
          <Route path='/' element={<Layout />} >
            <Route exact path='/' element={<RegistrationPage/>} />
          </Route>
      </Routes>
    );
  }
}
